<template>
  <default-modal :open="open" @close="close" maxWidthClass="max-w-2xl">
    <template slot="header">
      Ajouter un membre
    </template>
    <div slot="body" class="py-6 px-6">
      <div
        class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative text-left w-full flex flex-col"
        role="alert"
        v-if="errors.length > 0"
      >
        <div>
          <p v-for="(error, i) in errors" :key="i" class="w-full block">
            {{ error }}
          </p>
        </div>
        <button @click="clearErrors">
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
            <svg
              class="fill-current h-6 w-6 text-red-500"
              role="button"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <title>Close</title>
              <path
                d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
              />
            </svg>
          </span>
        </button>
      </div>
      <div class="text-left">
        <div class="grid grid-cols-6 gap-3">
          <div class="col-span-6 sm:col-span-3">
            <label
              for="first_name"
              class="block text-sm font-medium leading-5 text-gray-700"
              >Prénom</label
            >
            <input
              v-model="member.first_name"
              id="first_name"
              class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            />
          </div>
          <div class="col-span-6 sm:col-span-3">
            <label
              for="last_name"
              class="block text-sm font-medium leading-5 text-gray-700"
              >Nom</label
            >
            <input
              v-model="member.last_name"
              id="last_name"
              class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            />
          </div>
          <div class="col-span-6 sm:col-span-4">
            <label
              for="email"
              class="block text-sm font-medium leading-5 text-gray-700"
              >Email</label
            >
            <input
              v-model="member.email"
              id="email"
              class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense px-6 pb-4"
    >
      <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
        <button
          @click="submit"
          type="button"
          class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
          Ajouter
        </button>
      </span>
      <span
        class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1"
      >
        <button
          @click="close"
          type="button"
          class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
          Annuler
        </button>
      </span>
    </div>
  </default-modal>
</template>

<script>
import DefaultModal from "@/components/global/modals/DefaultModal";
export default {
    components: {
        DefaultModal
    },
    data() {
        return {
            member: {
                first_name: null,
                last_name: null,
                email: null
            },
            errors: []
        };
    },
    props: {
        open: {
            type: Boolean,
            required: true
        }
    },
    computed: {},
    methods: {
        close() {
            this.$emit("close");
        },
        submit() {
            const body = { ...this.member };
            this.$store
                .dispatch("team/store", body)
                .then(res => {
                    if (res.status === 200) {
                        this.close();
                        this.clearErrors();
                    } else {
                        let err = [];
                        Object.values(res.response.data.errors).forEach(er => {
                            err = [...err, ...er];
                        });
                        this.errors = err;
                    }
                })
                .catch(err => {
                    console.log(err.response);
                });
        },
        clearErrors() {
            this.errors = [];
        }
    }
};
</script>